<template>
<v-container>
      <v-dialog v-model="dialog" persistent max-width="1200" @input="closeDialog()">
        <v-card>  
            <v-container>  
          <v-card-text>
            <v-container>
             
                                <v-row>
                                        <v-col cols="12" md="6">
                                            
                                            <v-text-field type="text" name="DU" 
                                            v-model="account_info.dni"
                                            v-validate="'required'"
                                            label="*Documento"
                                            data-vv-as="Documento"
                                            placeholder="Documento" />
                                         </v-col>
                                        <v-col cols="12" md="6">
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="search()"
                                            >
                                            Buscar
                                            </v-btn>
                                            
                                            <!-- Botón de test para verificar reactividad -->
                                            <v-btn
                                                color="orange darken-1"
                                                text
                                                @click="testReactivity()"
                                            >
                                            Test
                                            </v-btn>
                                        </v-col>   
                                </v-row>
                                <v-row>
                                   
                                       <v-col cols="12" md="6">
                                            
                                            <v-text-field  type="text" name="name"
                                                v-model="account_info.name"
                                                v-validate="'required'"
                                                
                                                label="*Nombre"
                                                data-vv-as="Nombre"
                                                placeholder="Nombre"/>
                                        </v-col>
                                        
                                        <v-col cols="12" md="6">
                                            
                                            <v-text-field type="text" name="lastname"
                                                v-model="account_info.lastname"
                                                v-validate="'required'"
                                                label="*Apellido"
                                                data-vv-as="Apellido"
                                                placeholder="Apellido"/>
                                        </v-col>
                                   
                                   
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <div v-if="errors.has('name')" class="invalid-feedback">{{ errors.first('name') }}</div>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <div v-if="errors.has('lastname')" class="invalid-feedback">{{ errors.first('lastname') }}</div>
                                            </v-col>
                                        </v-row>
                                 
                                </v-row>
                                
                                <v-row>
                                    <v-col cols="12" md="6">
                                            <v-text-field type="text" name="telefono"
                                                v-model="account_info.telefono"
                                                v-validate="'required'"
                                                label="*Telefono"
                                                placeholder="Telefono"/>
                                        </v-col>

                                    <v-col cols="12" md="6">
                                        <v-label>Genero</v-label>
                                        <v-select
                                            class="style-select"
                                            name="gender"
                                            v-model="account_info.gender"
                                            :items="goptions"
                                            item-text="text"
                                            item-value="value"
                                            label="Género"
                                            v-validate="'required'"
                                            data-vv-as="Género"
                                        />
                                    </v-col>
                                    
                                </v-row>
                               
                                <v-row>       
                                    <v-col cols="12" md="6">
                                        <div v-if="errors.has('telefono')" class="invalid-feedback">{{ errors.first('telefono') }}</div>
                                    </v-col>
                                </v-row>


                                <v-row>
                                    
                                    <v-col cols="12" md="6">

                                        <v-label>Obra Social</v-label>
                                        <v-select
                                            class="style-select"
                                            name="insuranse"
                                            v-model="account_info.insuranse"
                                            :items="insuranseOptions"
                                            item-text="text"
                                            item-value="value"
                                            label="Obra Social"
                                            v-validate="'required'"
                                            data-vv-as="Obra Social"
                                        />
                                    
                                    </v-col>
                                    <v-col cols="12" md="6">
                                            
                                            <v-text-field type="date" name="dob" 
                                            v-model="account_info.dob"
                                            label="Fecha de Nacimiento"
                                            
                                            placeholder="Fecha de Nacimiento" />
                                    </v-col>

                                </v-row>

                                <v-row>
                                    <v-col cols="12" md="6">
                                        <v-text-field type="text" name="street"
                                            v-model="account_info.street"
                                            
                                            label="Direccion"
                                            placeholder="Direccion"/>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field type="text" name="city"
                                            v-model="account_info.city"
                                            
                                            label="Ciudad"
                                            placeholder="Ciudad"/>
                                    </v-col>
                                    

                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="6">
                                        <v-label>Provincia</v-label>
                                        <v-select
                                            class="style-select"
                                            name="province"
                                            v-model="account_info.province"
                                            :items="provincias"
                                            item-text="text"
                                            item-value="value"
                                            label="Provincia"
                                            v-validate="'required'"
                                            data-vv-as="Provincia"
                                        />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        
                                        <v-text-field type="text" 
                                            placeholder="Correo Electronico" name="mail"
                                            v-model="account_info.mail" ref="mail"
                                            label="E-Mail"
                                            v-validate="'email'"
                                            data-vv-as="E-Mail"
                                            />
                                    </v-col>
                                    
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="6">
                                        <div v-if="errors.has('mail')" class="invalid-feedback">{{ errors.first('mail') }}</div>
                                    </v-col>
                                </v-row>                

            </v-container>
            <small>*indica campos requeridos</small>
          </v-card-text>
          
  </v-container>
            
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                color="blue darken-1"
                text
                @click="$emit('close',true), dialog2 = false, resetData()"
                >
                Cerrar
                </v-btn>
                <v-btn
                color="blue darken-1"
                text
                @click="guardarDatos(),dialogo = false"
                >
                Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
                v-model="dialogo"
                hide-overlay
                persistent
                width="300"
            >
                <v-card
                color="primary"
                dark
                >
                <v-card-text>
                    Por favor espere
                    <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
                </v-card>
            </v-dialog>
</v-container>
</template>

<script>
import {initial_data} from "@/services/utils"
import {getPacienteData, getPeople, /* otros servicios que uses */} from '@/services/monolito';
import pacienteMixin from '@/mixins/pacienteMixin';
import errorsMixin from '@/mixins/errorsMixin';
import { required, email } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
//import Paciente from "@/components/Paciente_sin_btn.vue"

export default {
  name: "pacientecard",
  mixins: [pacienteMixin, validationMixin, errorsMixin],
  components: {
      //Paciente
  },
  validations: {
    account_info: {
      name: { required },
      lastname: { required },
      dni: { required },
      telefono: { required },
      mail: { email }
    }
  },
  data: function() {
    return {
        account_info: {
          gender: "",
          name: "",
          lastname: "",
          password: "" ,
          dni: "",
          roles: ["end_user"],
          dob: "",
          active: true,
          city: "",
          street:"",
          subdivision: "",
          insuranse: "",
          telefono: "",
          mail: "",
      },
        dialog2: false, 
        dialogo: false,
       
        goptions: [
                    { text: 'MASCULINO', value: 'm' },
                    { text: 'FEMENINO', value: 'f' }
                ],
        insuranseOptions: [],
        provincias: [],
    }
  },
  props: {
        dialog: Boolean,
        paciente_id: String,
    
  },
  computed: {
    // Simulación de VeeValidate v1/v2 errors usando Vuelidate
    errors() {
      return {
        has: (field) => {
          // Mapear campos a la estructura de Vuelidate
          const fieldMap = {
            'name': this.$v.account_info.name,
            'lastname': this.$v.account_info.lastname,
            'telefono': this.$v.account_info.telefono,
            'mail': this.$v.account_info.mail,
            'DU': this.$v.account_info.dni
          };
          
          const validator = fieldMap[field];
          return validator ? validator.$error : false;
        },
        first: (field) => {
          // Devuelve un mensaje de error apropiado
          const messages = {
            'name': 'El nombre es requerido',
            'lastname': 'El apellido es requerido',
            'telefono': 'El teléfono es requerido',
            'mail': 'Ingrese un email válido',
            'DU': 'El documento es requerido'
          };
          
          return this.errors.has(field) ? messages[field] : '';
        }
      };
    }
  },

  watch:{
      dialog: async function(val) {
         
          if (val){
            this.resetData();
            let data = await initial_data()
            
            this.insuranseOptions=data.insuranse
            this.provincias=data.provincias
            this.dialog2 = val
          }
      },
      paciente_id: async function(val){
            if (val === "0" || val === 0 || val === null || val === undefined || val === ""){
                this.resetData();
                return;
            }

            this.resetData();

            if (val!="0"){
                this.paciente = val
                // Usar el nuevo sistema unificado
                const resultado = await this.consultarPaciente(val);
                
                if (resultado.success) {
                    this.insert_data_paciente(resultado.data, resultado.tipoConsulta);
                } else {
                    console.error('Error consultando paciente:', resultado.error);
                }
            }
        }
  },

  methods: {
        closeDialog(){
            this.$emit('close');
            this.resetData();
        },
        async guardarDatos(){
            const backendPayload = { ...this.account_info };
            const emitObj = {
                ...backendPayload,
                characteristics: {
                    app_id: 'inmobiliaria-frontend'
                }
            };

            // Intentar guardar en backend
            const resultado = await this.guardarPaciente(backendPayload, 'create'); // Asumimos create o manejo inteligente en back

            if (resultado.success) {
                this.$emit('dataPaciente', emitObj);
                this.$emit('cambiarEstado', true);
                this.$emit('close');
                this.dialog2 = false;
                this.resetData();
                this.$alert({ title: 'Éxito', message: 'Paciente guardado correctamente', color: 'success' });
            } else {
                 this.$alert({ title: 'Error', message: 'Error al guardar paciente: ' + (resultado.error || 'Desconocido'), color: 'error' });
            }
        },
        async search(){

            
            // Usar el nuevo sistema unificado
            const resultado = await this.consultarPaciente(this.account_info.dni);


            if (!resultado.success) {

                this.resetData();
                await this.$alert({ title: 'No encontrado', message: 'Usuario NO ENCONTRADO, DEBE INGRESARLO', color: 'warning' });
                // No cerrar el modal para permitir el ingreso manual
            } else {

                this.insert_data_paciente(resultado.data, resultado.tipoConsulta);
                this.$emit('close');
            }
        },
        insert_data_paciente(dataResponse, tipoConsulta = 'id'){

            
            // Procesar los datos según el tipo de consulta
            const datosProcesados = this.procesarDatosPaciente(dataResponse, tipoConsulta);

            
            if (!datosProcesados || !datosProcesados.paciente) {
                console.error('Error: Datos del paciente inválidos');
                return;
            }
            
            const data = datosProcesados.paciente;
            const direccion = datosProcesados.direccion || {};
            const contacto = datosProcesados.contacto || {};
            

            
            // Los datos pueden venir directamente en data o dentro de data.party
            const party = data.party || data;

            
            if (party && party.gender) {
                this.account_info.gender = party.gender;

            }
            
            if (party && party.ref) {
                this.account_info.dni = party.ref;

            }
            
            if (party && party.name) {
                this.account_info.name = party.name;

            }
            
            if (party && party.lastname) {
                this.account_info.lastname = party.lastname;

            }
            
            // Si hay datos de usuario, usar el email
            if (datosProcesados.usuario && datosProcesados.usuario.email) {
                this.account_info.mail = datosProcesados.usuario.email;

            }
            
            if (party && party.dob) {
                this.account_info.dob = party.dob;

            }
            
            if (data.seguro && data.seguro.empresa) {
                this.account_info.insuranse = data.seguro.empresa.id;
            }
            
            if (direccion && Object.keys(direccion).length > 0) {
                this.account_info.street = direccion.street || '';
                this.account_info.city = direccion.city || '';
                if (direccion.provincia) {
                    this.account_info.subdivision = direccion.provincia.id;
                }
            }
            
            if (contacto && Object.keys(contacto).length > 0) {
                this.account_info.telefono = contacto.value || '';
            }
            

            
            // Forzar actualización de Vue
            this.$forceUpdate();
            
            // Emitir los datos del paciente encontrado para que se actualice el componente padre

            this.$emit('dataPaciente', this.account_info);
        },
        
        // Método de test para verificar reactividad
        testReactivity() {

            
            // Forzar actualización
            this.$forceUpdate();
            
            // Emitir cambios
            this.$emit('dataPaciente', this.account_info);
        },
        resetData(){
            this.account_info= {
            gender:"",
            name: "",
            lastname: "",
            password: "" ,
            dni:"",
            dob: "",
            active: true,
            city:"",
            street:"",
            subdivision:"",
            insuranse:  "",
            telefono:"",
            mail: "",
            }
        },
        handlerDataSave: function (datos){
           this.espereDialog = true
           this.account_info = datos
           this.guardarDatos()
       },
    }
}
</script>